module.exports = __webpack_public_path__ + "img/logo-keep-rising-white.453586ab.png";